import React  from "react";
import "./header/Header.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Fade  } from "react-reveal";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";

const ClientLogo = () => {
  const logos = [
    "/assets/images/icon/Apple.png",
    "/assets/images/icon/php.png",
    "/assets/images/icon/React.png",
    "/assets/images/icon/Android.png",
    "/assets/images/icon/Photoshop.png",
    "/assets/images/icon/Illustrator.png",
  ];

  

  return (
    <>
      <div className="boxed-wrapper">
        <div className="clients-one p_relative pt_50 mt_50 mpb_5">
          <div className="bg-layer p_absolute l_0 parallax_none set_img"></div>
          <div className="auto-container">
            <div className="inner-box p_relative z_1">
              <Fade >
              <h2 className="d_block fs_42 fw_bold pt_50 centred t_15">
                Our Expertise
              </h2>
              </Fade>
              {/* <div className="five-item-carousel owl-carousel owl-theme owl-nav-none owl-dots-none pt_50"> */}
              <div className="pt_50 pb_50">
                <div className="clients-logo-box d_flex w-100">
                  <Swiper
                    slidesPerView={1}
                    spaceBetween={10}
                    loop={true}
                    autoplay={{
                      delay: 1000,
                      disableOnInteraction: false,
                    }}
                    breakpoints={{
                      640: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                      },
                      768: {
                        slidesPerView: 4,
                        spaceBetween: 40,
                      },
                      1024: {
                        slidesPerView: 5,
                        spaceBetween: 50,
                      },
                    }}
                    modules={[Pagination, Autoplay]}
                    className="mySwiper"
                  >
                    {logos.map((logo, i) => {
                      return (
                        <SwiperSlide key={i}>
                          <img key={i} src={logo} alt="LOGO" />
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>

                  {/* <Carousel
                    swipeable={false}
                    draggable={true}
                    showDots={false}
                    responsive={responsive}
                    ssr={true} // means to render carousel on server-side.
                    infinite={true}
                    autoPlay={true}
                    autoPlaySpeed={1000}
                    keyBoardControl={true}
                    // customTransition="all .5"
                    transitionDuration={500}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["desktop", "mobile"]}
                    rewind={false}
                    rewindWithAnimation={false}
                    rtl
                    shouldResetAutoplay
                    sliderClass=""
                    slidesToSlide={1}
                    // deviceType={this.props.deviceType}
                    // dotListClass="custom-dot-list-style"
                    // itemClass="carousel-item-padding-40-px"
                  >
                    {logos.map((logo) => {
                      return <img key={logo} src={logo} alt="LOGO" />;
                    })}
                    {fakerData.map((logo) => {
                      return <img key={logo.image} src={logo.image} alt="LOGO" />;
                    })}

                    <img src={logos[0]} alt="LOGO" />
                    <img src={logos[1]} alt="LOGO" />
                    <img src={logos[2]} alt="LOGO" />
                    <img src={logos[3]} alt="LOGO" />
                    <img src={logos[4]} alt="LOGO" />
                  </Carousel> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientLogo;
